import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import { Table} from 'react-bootstrap';

var Config = require('../../../config');

class ModalConfirmUnits extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveIncident = this.saveIncident.bind(this);
		this.onManifestationChange = this.onManifestationChange.bind(this);
		this.onHourChange = this.onHourChange.bind(this);

		this.state = {
		    show: false,
		    unitsAdded:[],
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(item,id) {
		this.setState({ show: true});	
		fetch(Config.default.apiGateway.URL+'units_asociation?id='+id+'&component_type='+item.component_type,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({ 
				unitsAdded: response,
			});
		})
	}

	handleChangeTable = indice =>  e => {
		this.state.unitsAdded[indice].checked = e.target.checked;
	}

	setData(incidents){

		this.setState({
			moment_incident: incidents.incidents_extraction.moment_incident,
			manifestation_ids: incidents.manifestation_ids,
			incident_imputability: incidents.incidents_extraction.imputability_incident_id,
			incident_severity: incidents.incidents_extraction.severity_incident_id,
			observations: incidents.incidents_extraction.observations,
			method_form:"put",
			incident_ids: incidents.incident_ids,
		})		

		this.state.incidents_type.map(function (v,i){
			if(this.state.incident_ids.indexOf(v.id) !== -1){
				var incident = {};
				incident.id = v.id;
				incident.text = v.name;
				this.setState({
					incidents_list: [...this.state.incidents_list, incident]
				})
			}
		}.bind(this));
	}

	onManifestationChange(e){
		if(e.target.checked){
			this.setState({
				manifestation_ids: [...this.state.manifestation_ids, parseInt(e.target.value,10)]
			});
		}else{
			var array = [...this.state.manifestation_ids]; 
			var index = array.indexOf(parseInt(e.target.value));
			array.splice(index, 1);
			this.setState({manifestation_ids: array});
		}	
	}

	saveIncident(){
		var temp = []
		for (var i = 0; i < this.state.unitsAdded.length; i++) {
			if (this.state.unitsAdded[i].checked == true) {
				temp.push(this.state.unitsAdded[i].units_asociation.id);
			};
		};

		if(temp.length > 0){
			this.waiting_modal.handleShow('Generando...');			
			fetch(Config.default.apiGateway.URL+'units_asociation?health_facility='+sessionStorage.getItem("health_facilities_id"), {
				method:'post',
				body:JSON.stringify(temp),
				headers: new Headers({
					'Authorization' : 'Beares '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json;charset=UTF-8'
				})
			})
			.then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result) {
						swal('¡Error!', result, 'error');
					});
				}
			})
			.then(response => {
				if(response !== undefined){
					this.setState({ show: false});
				}
			});
		}else{
			swal('Error', 'No hay unidades a confirmar','error');
		}
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const ctrls = document.querySelectorAll('input,select');
	    let isFormValid = true;

	    ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			if (control.value === "") {
		        if(control !== null){
		            control.classList.add('error');
		        }
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
			        	control.classList.remove('error');
			    	}
		    	}
				res = true;
			}
		}

		return res;
	}

	handleChange = (event) => {
		this.setState({[event.target.name]:event.target.value});
	}

	//Evento para checkbox
	handleCheck = (event) => {
	    this.setState({
	      [event.target.name]: event.target.checked
	    });
	}

	onIncidentSelected = (e)=>{
		const incident = this.state[e.target.name];	
		incident.id    = e.target.value;
		incident.text  = e.target.options[e.target.selectedIndex].text

		this.setState({
			incident_type : incident
		});
	}

	onHourChange(e){
		var hour = moment(e.target.value, 'h:mm a');

		if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
			document.getElementById(e.target.id).classList.add("error");
			document.getElementById(e.target.name).style.borderColor = "red";
		}else{
			document.getElementById(e.target.name).style.borderColor = "#ccc";
			document.getElementById(e.target.id).classList.remove("error");
		}

		this.validateInput(e);
		this.setState({
			timestamp_hour:e.target.value
		})
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
      				form.elements[index].removeAttribute("style");      				
  					if(form.elements[index + 1].getAttribute("disabled") === null){	
    					if(form.elements[index + 1].getAttribute("type") === 'checkbox'){
							form.elements[index + 1].focus();
							form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
    					
    					}else{
    						form.elements[index + 1].focus();
    					}
    					
  					}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				}
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Confirmar Unidades</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<form noValidate>
			        	<div className="row" style={{margin:"10px"}}>	
					    </div>
				    </form>

				    <div className="col-xs-12"> 
		              <Table responsive hover style={{margin:"0px"}}>
		                <thead>
		                  	<tr>
		                    	<th>No Unidad</th>
		                    	<th>Componente</th>
		                    	<th>Volumen</th>
		                    	<th >Confirmar</th>
		                  	</tr>
		                </thead>
		                <tbody>
		                 {this.state.unitsAdded.map( (unit, index) => (
		                    <tr key={index}>
		                      	<td>{unit.unit.unit_number}</td>
		                      	<td>{unit.blood_component.component}</td>
		                      	<td>{unit.unit.volume} </td>
		                      
		                      	<td  style={{textAlign: "center",padding: "2px",}}>
		                        	<input className="form-check-input" type="checkbox" name={"check_"+index} id={"check_"+index} 
					        		value={unit.units_asociation.confirm} onChange={ this.handleChangeTable(index,unit) } />
		                      	</td>
		                    </tr>
		                    ))}
		                </tbody>
		              </Table>
		            </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveIncident}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
	      	</div>
		);
	}
}

export default translate('translations')(ModalConfirmUnits);